import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Box, CircularProgress, Grid, Paper, Typography } from '@mui/material';
import fundedAPI from '../../api/funded';
import FundedNav from './FundedNav';
import LenderSummary from '../../components/funded/LenderSummary';
import SimpleBarChart from '../../components/funded/SimpleBarChart';

export default function LendersView() {
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const res = await fundedAPI.getLenders();
        setRows(res.data.data || []);
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const topChart = rows.slice(0, 12).map((r) => ({ label: r.lender, total: r.totalCommissions, count: r.commissionCount }));

  // Clicking a lender drills into the ledger pre-filtered by that lender.
  const openLender = (lender) => navigate(`/sales/funded/ledger?lender=${encodeURIComponent(lender)}`);

  return (
    <Container maxWidth="xl" sx={{ py: 3 }}>
      <FundedNav title="Lender Roll-up" subtitle="Totals and counts across every lender" />

      {loading ? (
        <Box display="flex" justifyContent="center" py={8}><CircularProgress /></Box>
      ) : (
        <Grid container spacing={2}>
          <Grid item xs={12} md={8}>
            <LenderSummary rows={rows} onSelect={openLender} />
          </Grid>
          <Grid item xs={12} md={4}>
            <Paper elevation={0} sx={{ p: 2, border: '1px solid', borderColor: 'divider', borderRadius: 2 }}>
              <Typography variant="subtitle2" fontWeight={700} sx={{ mb: 2 }}>Top Lenders by Commission</Typography>
              <SimpleBarChart data={topChart} color="#2563eb" />
            </Paper>
          </Grid>
        </Grid>
      )}
    </Container>
  );
}
